import script from "./ScissorsPaperRock.vue?vue&type=script&setup=true&lang=js"
export * from "./ScissorsPaperRock.vue?vue&type=script&setup=true&lang=js"

import "./ScissorsPaperRock.vue?vue&type=style&index=0&id=464d365e&lang=css"

const __exports__ = script;

export default __exports__